import { Navigate, Outlet } from 'react-router-dom';

import useIsAppBlocked from 'commons/utils/hooks/useIsAppBlocked';

import Loading from 'domains/widgets/loading/loading';

import { ROUTES } from './constants';

const AppBlockedGuard = () => {
  const { isBlocked, isLoading } = useIsAppBlocked();

  if (isLoading) {
    return <Loading />;
  }

  if (isBlocked) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
};

export default AppBlockedGuard;
